const arMessages = {
  /* 01.General */
  "chat.end": "أعد بدء محادثة الدردشة الخاصة بك",
  "chat.endall": "نهاية المحادثة",
  "chat.cancel": "يلغي",
  "chat.cookie":
    "يستخدم هذا المساعد الرقمي ملفات تعريف الارتباط لضمان حصولك على أفضل تجربة",
  "chat.learn": "يتعلم أكثر",
  "chat.minimize": "تصغير",
  "chat.hide": "يغلق",
  "chat.hidebot.text": "إغلاق سيجعل الصورة الرمزية تختفي لمدة 15 دقيقة",
  "chat.hidebot": "إغلاق (إخفاء) الصورة الرمزية",
  "chat.restart": "اعادة البدء",
  "switch.language": "تبديل اللغة",
  "switch.property": "تبديل الممتلكات",
  "restart.converstation": "أعد تشغيل المحادثة",
  "chat.endtext": "هل أنت متأكد أنك تريد إنهاء الدردشة الحالية؟",
  "check.availabity": "التحقق من الصلاحية",
  "check.availabity.submit": "إرسال",
  "check.availabity.cancel": "يلغي",
  "check.availabity.adults": "الكبار ",
  "check.availabity.children": "أطفال",
  "check.availabity.child.age": "العمر - الطفل",
  "feedback.leave": "اترك تقييم للخدمة",
  "feedback.leave.message": "اترك رسالة",
  "placeholder.name": "Name",
  "placeholder.firstName": "First Name",
  "placeholder.lastName": "Last Name",
  "placeholder.email": " Email",
  "placeholder.phoneNumber": "Phone Number",
  "placeholder.zipcode": "Zip Code",
  "caseform.title": "إرسال قضية",
  "caseform.system": "النظام",
  "caseform.loading.systems": "جاري تحميل الأنظمة...",
  "caseform.select.system": "اختر النظام",
  "caseform.error.systems": "خطأ في تحميل الأنظمة",
  "caseform.scenario": "السيناريو",
  "caseform.loading.scenarios": "جاري تحميل السيناريوهات...",
  "caseform.select.scenario": "اختر السيناريو",
  "caseform.error.scenarios": "خطأ في تحميل السيناريوهات",
  "caseform.topic": "الموضوع",
  "caseform.loading.topics": "جاري تحميل المواضيع...",
  "caseform.select.topic": "اختر الموضوع",
  "caseform.error.topics": "خطأ في تحميل المواضيع",
  "caseform.subject": "الموضوع",
  "caseform.description": "الوصف",
  "caseform.submit": "إرسال",
  "caseform.cancel": "إلغاء",
  "caseform.success.title": "تم إنشاء القضية",
  "caseform.success.message": "تم إنشاء قضيتك بنجاح.",
  "caseform.success.caseNumber": "رقم القضية:",
  "caseform.success.ok": "موافق",
  "simpleaction.title": "اختر إجراء",
  "simpleaction.body":
    "يرجى تحديد أحد الخيارات التالية:{br}{b}إنشاء حالة{/b} لتقديم طلب دعم ، أو {b}بدء محادثة{/b} للتواصل مع وكيل الآن.",
  "simpleaction.startchat": "بدء محادثة",
  "simpleaction.createcase": "إنشاء حالة",
  "caseform.error.generic": "خطأ في إنشاء الحالة.",
  "caseform.error.generic.message":
    "حدث خطأ أثناء إنشاء حالتك. يرجى المحاولة مرة أخرى لاحقًا.",
};
export default arMessages;
